import { LazyLoadedStates, LazyLoadedStatesManager } from '@edl-development/edl-common';

export const AnecdotalObservationLazyLoadedStates = new LazyLoadedStatesManager<{ 
    base: LazyLoadedStates, 
    anecdotalDetails: LazyLoadedStates 
}> ({
    base: {
        name: 'authenticated.user-summary.anecdotal',
        url: '/anecdotal'
    },
    anecdotalDetails: {
        name: 'authenticated.user-summary.anecdotal.details',
        url: '/details/:userId/:observationId',
    }
}, 
() => import('src/app/observations/anecdotal/anecdotal.module')
    .then((result: { AnecdotalModule: any }) => result.AnecdotalModule)
);
